import React, {Component} from 'react';
import './Library.css';
import kenaLogo from '../../assets/logo.png';
import config from '../../config';
import axios from 'axios';
import { 
    CognitoUserPool, 
    AuthenticationDetails, 
    CognitoUser,
    CognitoUserSession,
    CognitoUserAttribute
} from 'amazon-cognito-identity-js';
import bgImage from '../../assets/bg2.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import produce from 'immer';
import CryptoJS from 'crypto-js';

import Navbar from '../../componentes/Navbar/Navbar';
import Input from '../../componentes/Input/Input';
import Button from '../../componentes/Button/Button';
import SearchbarNav from '../../componentes/SearchbarNav/SearchbarNav';
import Music from '../../componentes/Music/Music';

class Library extends Component{
    state={
        userId: '',
        myMusic: [],
        uploadMusic1: 'Upload Music',
        uploadMusic2: 'Upload Music',
        loadingIcon: false,
        showMobileNavbar: false,
        playPauseAudio: {
            musicId: null,
            fileUrl: null,
            playing: false,
        }
    }

    componentDidMount(){
        document.addEventListener('mousedown', this.handleOutsideClick);

        // const ajaxData = {
        //     "user_id": userId,
        //     'page_no': 0,
        //     'stage': config.stage,
        // }

        // axios({
        //     url: config.apiGateway.get_music_list,
        //     method: 'post',
        //     data: ajaxData,
        //     headers: {'Authorization': session.getIdToken().getJwtToken()}, 
        // }).then(response =>{
        // console.log('success response: ', response);
        // }).catch(err =>{
        //     console.log('err: ', err);
        // });
        
        const poolData = {
            UserPoolId: config.pool_data.UserPoolId, // Your user pool id here
            ClientId: config.pool_data.ClientId, // Your client id here
        };

        var userPool = new CognitoUserPool(poolData);
        var cognitoUser = userPool.getCurrentUser();

        console.log('cognito user: ', cognitoUser);

        if (cognitoUser != null) {
            // loading icon----------------------------------
            this.setState({
                loadingIcon: true
            });

            // save userid
            const userId = cognitoUser.username;
            this.setState({
                userId: userId
            });

            // get token
            this.getAuthenticatedUser().getSession(function(err, session){
                if(err){
                    alert('error: session expired');
                }
                else{
                    const ajaxData = {
                        // "user_id": userId,
                        "music_genre_id": 'home', 
                        'stage': config.stage,
                    }

                    axios({
                        url: config.apiGateway.get_music_library,
                        method: 'post',
                        data: ajaxData,
                        headers: {'Authorization': session.getIdToken().getJwtToken()}, 
                    }).then(response =>{
                        console.log('succeeded loading data on page load');  
                        console.log('response', response);      
                        
                        this.setState({
                            data: response.data,
                            loadingIcon: false
                        });

                    }).catch(err =>{
                        console.log('err: ', err);
                    });
                    
                }
            }.bind(this));

        }
        else{
            window.location.href = './index.html?v=17';
        }
    }

    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleOutsideClick);
    } 

    handleOutsideClick = (e) =>{
        // clicked navbar?
        if(this.navbarNode.contains(e.target)){
            
        }
        else{
            console.log('outside navbar');
            this.setState({
                showMobileNavbar: false
            });
        }
    }

    getAuthenticatedUser = () =>{
        const poolData = {
            UserPoolId: config.pool_data.UserPoolId, // Your user pool id here
            ClientId: config.pool_data.ClientId, // Your client id here
        };

        var userPool = new CognitoUserPool(poolData);
        return userPool.getCurrentUser();
    }

    checkLoggedInemailIsSameAsSendingRequest = (snedingEmail) =>{
        // console.log('sendingmeial: ', snedingEmail);
        const userId = this.state.userId;
        // console.log('userid: ', userId);
        if(userId == snedingEmail){
            return true;
        }
        else{
            return false;
        }
    }

    toggleMobileNavbar = () =>{
        this.setState({
            showMobileNavbar: !this.state.showMobileNavbar
        });
    }

    uploadMusicHandler = (ev) =>{
        console.log('type: ', ev.target.type);
        if(ev.target.type && ev.target.type === 'file'){
            // display file name when file was selected
            const label = ev.target.nextElementSibling;
            const labelVal = label.innerHTML;

            let fileName = '';
            if(ev.target.files && ev.target.files.length > 1){
                fileName = (ev.target.getAttribute('data-multiple.caption') || '').replace('{count}', ev.target.files.length);
            }
            else{
                fileName = ev.target.value.split('\\').pop();

                console.log('e target files[0]: ', ev.target.files[0]);
                console.log('file name: ', ev.target.files[0].name);
                console.log('file type: ', ev.target.files[0].type);
                console.log('file size: ', ev.target.files[0].size/1024/1024 + 'MB');
            }

            if(fileName){
                const span = ev.target.name +1;
                console.log('span state: ', span);
                this.setState({ [span]: fileName });

                // file extension and size vertification
                const fileNameSplit =  ev.target.files[0].name.split('.');
                let fileExtension = fileNameSplit[fileNameSplit.length -1];
                fileExtension = fileExtension.toLowerCase();
                const fileSize = Math.round(ev.target.files[0].size/1024/1024);

                const userId = this.state.userId;
                console.log('ext, size: ', fileExtension + ", ", fileSize);
                console.log('filenamesplit[0]: ', fileNameSplit[0]);
                console.log('userid: ', userId);

                let isAcceptableExtension = null;
                if(fileExtension == "mp3" || fileExtension == "m4a" || fileExtension == "ogg" || fileExtension == "wav"){
                    isAcceptableExtension = true;
                }
                else{
                    // if wong extansion
                    alert('Max file size : 2MB. Supported extensions: mp3, m4a, ogg, wav');
                }

                // check file extension and size (2MB)
                if(isAcceptableExtension && fileSize < 2){
                    console.log('file size and ext is good');

                    // loading icon------------------------------------
                    this.setState({
                        loadingIcon: true,
                    });

                    // base64--------------------------------------------
                    // testing api post
                    let userData = {
                        'userId': userId,
                        'fileName': fileNameSplit[0],
                        'created_at': Date.now(),   // UTC timestamp in milliseconds
                        'stage': config.stage,
                    };

                    const userFile = ev.target.files[0];

                    console.log('userdata: ', userData);

                    const that = this;

                    // get binary string-----------------------------------------
                    (function handleFileSelect(evt) {
                        var f = userFile; // FileList object
                        var reader = new FileReader();
                        // Closure to capture the file information.
                        reader.onload = (function(theFile) {
                            return function(e) {                                       

                                var binaryData = e.target.result;
                                //Converting Binary Data to base 64
                                var base64String = window.btoa(binaryData);
                                userData.user_file = base64String;

                                console.log('base64string: ', base64String);

                                // get token--------------------------------------------------
                                console.log('that', that);
                                that.getAuthenticatedUser().getSession(function(err, session){
                                    if(err){
                                        alert('error: session expired');
                                    }
                                    else{

                                        // check email
                                        if(that.checkLoggedInemailIsSameAsSendingRequest(userData.userId)){

                                             axios({
                                                // url: config.apiGateway.uploadfile,
                                                method: 'post',
                                                data: JSON.stringify(userData),
                                                contentType: 'application/json',
                                                headers: {'Authorization': session.getIdToken().getJwtToken()}, 
                                            }).then(response =>{
                                                console.log('success response: ', response);

                                            }).catch(err =>{
                                                console.log('err: ', err);
                                            });

                                        }
                                    }
                                })

                            };
                        })(f);
                        // Read in the image file as a data URL.
                        reader.readAsBinaryString(f);
                    })();

                }
            }
            else{
                const label = ev.target.name +2;
                this.setState({[label]:labelVal});
            }
        }
    }

    audioEl = document.createElement('audio');

    playPauseAudio = (newMusicId, newFileUrl) =>{
        // let currentPlayingId = null;

        console.log('test');
        console.log('newMusicId: ', newMusicId);
        console.log('old musicid: ', this.state.playPauseAudio.musicId);
        console.log('newFileUrl: ', newFileUrl);

        // check if user wants to play different music
        if(this.state.playPauseAudio.musicId === newMusicId){
            console.log('same music id');
            console.log('t f: ', this.audioEl.paused);
            if(this.audioEl.paused){
                console.log('music paused');
                // play music
                this.audioEl.play();
                // update UI
                const newPlayPauseAudio = {...this.state.playPauseAudio};
                newPlayPauseAudio.playing = true;
                this.setState({
                   playPauseAudio: newPlayPauseAudio
                });
            }
            else{
                console.log('music is playing');
                // pause music
                this.audioEl.pause();
                // update UI
                const newPlayPauseAudio = {...this.state.playPauseAudio};
                newPlayPauseAudio.playing = false;
                this.setState({
                    playPauseAudio: newPlayPauseAudio
                });
            }
        }
        else{
             // play a different music
             console.log('different music');

             const that = this;

            // ajax call ----------------------------------------
            // const path = newFileUrl.split(kenaConfig.musicBucket)[1];
            const path = newFileUrl.split(config.bucket.musicBucket)[1];

            console.log('path: ', path);

            const ajaxData = {
                path: path,
                'stage': config.stage,
            }

            this.getAuthenticatedUser().getSession(function(err, session){
                if(err){
                    alert('error: session expired');
                }
                else{

                    console.log('ajaxdata: ', ajaxData);

                    axios({
                        url: config.apiGateway.downloadfile,
                        method: 'post',
                        data: JSON.stringify(ajaxData),
                        headers: {'Authorization': session.getIdToken().getJwtToken()}, 
                    }).then(response =>{
                        console.log('success response: ', response);

                        // play audio player---------------------
                        
                        that.audioEl.src = response.data;
                        that.audioEl.play();
                        // update UI
                        const newPlayPauseAudio = {...that.state.playPauseAudio};
                        newPlayPauseAudio.musicId = newMusicId;
                        newPlayPauseAudio.fileUrl = newFileUrl;
                        newPlayPauseAudio.playing = true;

                        that.setState({
                            playPauseAudio: newPlayPauseAudio
                        });

                    }).catch(err =>{
                        console.log('err: ', err);
                    });
                }
            });
        }
    }

    checkAudioIcon = (musicId) =>{
        console.log('musicId: ', musicId);
        console.log('state musicId: ', this.state.playPauseAudio.musicId);
        console.log('state plying: ', this.state.playPauseAudio.playing);
        if(this.state.playPauseAudio.musicId === musicId && this.state.playPauseAudio.playing){
            return 'pauseIcon';
        }
        else{
            return 'playIcon'
        }
    }

  

    diagnosticsButtonClickHandler = (ev, musicId) =>{
        ev.preventDefault();
        console.log('diag button clicked');
        console.log('musicId: ', musicId);

        const myPassword = 'fujiappletastgreat';

        const encryptedUserId = CryptoJS.AES.encrypt(this.state.userId, myPassword);
        const encryptedMusicId = CryptoJS.AES.encrypt(musicId, myPassword);
        
        const musicData = {
            'userId': encryptedUserId.toString(),
            'authorId': encryptedUserId.toString(),
            "musicId": encryptedMusicId.toString(),
        }

        localStorage.setItem('kenaMusicData', JSON.stringify(musicData));

        // console.log('redirect to diagnostics page');
        window.location.href = './diagnostics';

    }

    render(){
        console.log('======================', this.state);

        let loading = null;
        if(this.state.loadingIcon){
            loading = <div className='loading'>
                    <FontAwesomeIcon
                        icon={faSpinner}
                        color='#4f4f4f'
                        size='6x'
                        spin/>
                </div>
        }

      
    
        return (
            <div className='Mymusic'>
                <section>
                <div ref={node => {this.navbarNode = node;}}>
                    <Navbar
                        showMobileNavbar={this.state.showMobileNavbar}
                        clicked={this.toggleMobileNavbar}/>
                </div>    

                <div style={{paddingTop:120+'px'}}></div>

                <SearchbarNav
                    changed={this.uploadMusicHandler}
                    uploadMusic1={this.state.uploadMusic1}
                    uploadMusic2={this.state.uploadMusic2}
                />

                <h1>Library</h1>  

                {loading}              
                  
                </section>
            </div>
        )
    }
}

export default Library;